// The ambient engineering grid — a fixed coordinate plane behind the marketing /
// auth surfaces (login, plans), mirroring the landing site's site-wide grid motif
// so the product feels continuous with branchcad.com.
//
// Major lines every 112px, minor every 28px (4 minor per major) — the drafting
// cadence from the product canvas. Colours come from the live --cad-* tokens
// (light = the landing's #f6f8fa sheet with #d8dee4 grid; dark degrades to the
// app's dark grid), and a radial mask fades the plane toward the edges so it
// reads as quiet context. Purely decorative: aria-hidden + pointer-events-none.
export default function BrandBackdrop() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-10"
      style={{
        backgroundImage: `
          linear-gradient(to right, var(--cad-grid) 1px, transparent 1px),
          linear-gradient(to bottom, var(--cad-grid) 1px, transparent 1px),
          linear-gradient(to right, color-mix(in srgb, var(--cad-grid) 55%, var(--cad-bg)) 1px, transparent 1px),
          linear-gradient(to bottom, color-mix(in srgb, var(--cad-grid) 55%, var(--cad-bg)) 1px, transparent 1px)
        `,
        backgroundSize: '112px 112px, 112px 112px, 28px 28px, 28px 28px',
        backgroundPosition: '-1px -1px',
        maskImage: 'radial-gradient(125% 95% at 50% 0%, #000 50%, transparent 100%)',
        WebkitMaskImage: 'radial-gradient(125% 95% at 50% 0%, #000 50%, transparent 100%)',
      }}
    />
  );
}
